import { isServiceRequestsEnabled } from '~/cynqueModules/isServiceRequestsEnabled'

// Named middleware -- applied by the Service Request pages via definePageMeta, as
// 'service-requests-gate' (kebab-cased filename, like 'home-redirect'). Sends a
// Service Request URL Home while the feature is off: against a live API with no
// Service Request endpoints, the page would only fail. See isServiceRequestsEnabled.
export default defineNuxtRouteMiddleware(() => {
  if (!isServiceRequestsEnabled()) {
    console.debug(
      '[middleware/serviceRequestsGate.ts] Service Requests are off. Redirecting to /Home.'
    )
    return navigateTo('/Home')
  }
})
